var _path, _path2, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutMicro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0681 17.3943C14.3202 17.7885 13.4811 18 12.6201 18C11.2277 18 9.89237 17.4469 8.90781 16.4623C7.92324 15.4777 7.37012 14.1424 7.37012 12.75V11.25C7.37012 11.0511 7.2911 10.8603 7.15045 10.7197C7.0098 10.579 6.81903 10.5 6.62012 10.5C6.4212 10.5 6.23044 10.579 6.08979 10.7197C5.94913 10.8603 5.87012 11.0511 5.87012 11.25V12.75C5.87014 14.4104 6.48208 16.0126 7.58895 17.2503C8.69583 18.4879 10.22 19.2743 11.8701 19.459V21.75H8.87012C8.6712 21.75 8.48044 21.829 8.33979 21.9697C8.19913 22.1103 8.12012 22.3011 8.12012 22.5C8.12012 22.6989 8.19913 22.8897 8.33979 23.0303C8.48044 23.171 8.6712 23.25 8.87012 23.25H16.3701C16.569 23.25 16.7598 23.171 16.9004 23.0303C17.0411 22.8897 17.1201 22.6989 17.1201 22.5C17.1201 22.3011 17.0411 22.1103 16.9004 21.9697C16.7598 21.829 16.569 21.75 16.3701 21.75H13.3701V19.459C14.352 19.3491 15.2893 19.0262 16.1206 18.5219L15.0681 17.3943ZM18.9854 14.9962C19.238 14.2806 19.3701 13.5216 19.3701 12.75V11.25C19.3701 11.0511 19.2911 10.8603 19.1504 10.7197C19.0098 10.579 18.819 10.5 18.6201 10.5C18.4212 10.5 18.2304 10.579 18.0898 10.7197C17.9491 10.8603 17.8701 11.0511 17.8701 11.25V12.75C17.8701 13.0733 17.8403 13.3936 17.7822 13.707L18.9854 14.9962Z",
    fill: "url(#paint0_linear_5719_77816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89819 4.04192L16.3701 12.0476V4.5C16.3701 3.50544 15.975 2.55161 15.2718 1.84835C14.5685 1.14509 13.6147 0.75 12.6201 0.75C11.6256 0.75 10.6717 1.14509 9.96847 1.84835C9.37405 2.44277 8.99979 3.21619 8.89819 4.04192ZM13.9911 16.2404L8.87012 10.7536V12.75C8.87012 13.7446 9.26521 14.6984 9.96847 15.4017C10.6717 16.1049 11.6256 16.5 12.6201 16.5C13.0939 16.5 13.5585 16.4103 13.9911 16.2404Z",
    fill: "url(#paint1_linear_5719_77816)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.68023,
    y1: 4.0342,
    x2: 19.6543,
    y2: 18.9399,
    stroke: "url(#paint2_linear_5719_77816)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5719_77816",
    x1: 26.1201,
    y1: 16.875,
    x2: 13.3909,
    y2: 3.39702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5719_77816",
    x1: 20.1201,
    y1: 8.625,
    x2: 7.89276,
    y2: 2.80245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5719_77816",
    x1: 26.7553,
    y1: 28.342,
    x2: 28.1492,
    y2: 26.9105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutMicro);
export default __webpack_public_path__ + "static/media/cut-micro.8f636124c3687d23865ed59f30626098.svg";
export { ForwardRef as ReactComponent };